module.exports = __webpack_public_path__ + "media/crypto/zusd-882ddf8b.png";